module.exports = __webpack_public_path__ + "img/news_banner.a91764b3.png";